import { FC } from "react";
import { Marker } from "react-map-gl/mapbox";
import { BoundaryPoint } from "../../types";

interface BoundaryMarkersProps {
  boundaryPoints: BoundaryPoint[];
  isBoundaryMode: boolean;
  onDragEnd: (event: any, pointId: string) => void;
  onClick: (event: any, pointId: string) => void;
}

export const BoundaryMarkers: FC<BoundaryMarkersProps> = ({
  boundaryPoints,
  isBoundaryMode,
  onDragEnd,
  onClick,
}) => {
  // Boundary marker size variables
  const boundaryMarkerMinWidth = isBoundaryMode ? "18px" : "14px";
  const boundaryMarkerFontSize = isBoundaryMode ? "12px" : "10px";

  return (
    <>
      {boundaryPoints.map((point) => (
        <Marker
          key={point.id}
          longitude={point.coordinates.longitude}
          latitude={point.coordinates.latitude}
          anchor="center"
          draggable={isBoundaryMode}
          onDragEnd={(event) => onDragEnd(event, point.id)}
          onClick={(event) => {onClick(event, point.id)}}
        >
          <div
            className={`boundary-point-marker ${
              isBoundaryMode ? "boundary-mode-active" : ""
            }`}
          >
            <span
              role="img"
              aria-label={`Boundary Point ${point.order + 1}`}
              style={{
                fontSize: boundaryMarkerFontSize,
                color: "white",
                fontWeight: "bold",
                backgroundColor: "red",
                borderRadius: "50%",
                width: boundaryMarkerMinWidth,
                height: boundaryMarkerMinWidth,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "2px solid red",
                lineHeight: "1",
                textAlign: "center",
                userSelect: "none",
                minWidth: boundaryMarkerMinWidth,
                minHeight: boundaryMarkerMinWidth,
                maxWidth: boundaryMarkerMinWidth,
                maxHeight: boundaryMarkerMinWidth,
                boxSizing: "border-box",
              }}
            >
              {point.order + 1}
            </span>
          </div>
        </Marker>
      ))}
    </>
  );
};
